import client from './client';

export const listTasks = () => client.get('/tasks').then((r) => r.data);
export const getTask = (id) => client.get(`/tasks/${id}`).then((r) => r.data);
export const createTask = (payload) => client.post('/tasks', payload).then((r) => r.data);
export const createDirectTask = (payload) => client.post('/tasks/direct', payload).then((r) => r.data);
export const updateTask = (id, payload) => client.put(`/tasks/${id}`, payload).then((r) => r.data);
export const deleteTask = (id) => client.delete(`/tasks/${id}`).then((r) => r.data);
export const createOrderTask = (payload) => client.post('/tasks/from-orders', payload).then((r) => r.data);
export const createCustomerTask = (payload) => client.post('/tasks/from-customers', payload).then((r) => r.data);
export const confirmTask = (id) => client.post(`/tasks/${id}/confirm`).then((r) => r.data);
export const assignTask = (id, userId) => client.post(`/tasks/${id}/assign`, { userId }).then((r) => r.data);
export const saveItemNote = (id, custId, note, resultStatus) =>
  client.post(`/tasks/${id}/items/note`, { custId, note, resultStatus }).then((r) => r.data);
export const submitTask = (id) => client.post(`/tasks/${id}/submit`).then((r) => r.data);
export const reviewItem = (id, custId, newState, reviewNote) =>
  client.post(`/tasks/${id}/items/review`, { custId, newState, reviewNote }).then((r) => r.data);
export const finalizeTask = (id) => client.post(`/tasks/${id}/finalize`).then((r) => r.data);
export const selfFinishTask = (id) => client.post(`/tasks/${id}/self-finish`).then((r) => r.data);
export const replyTask = (id, text) => client.post(`/tasks/${id}/reply`, { text }).then((r) => r.data);
